/* 興味関心チェック */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as AppUserActions from '../actions/AppUser';
import * as InterestCheckActions from '../actions/InterestCheck';
import * as HeaderActions from '../actions/Header';
import UserInterestCheck from '../components/UserInterestCheck';

const mapStateToProps = (state: any) => {
  return {
    // configureStore
    auth: state.auth,
    moffAPI: state.moffAPI,
    appUser: state.appUser,
    interestCheck: state.interestCheck,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    appUserActions : bindActionCreators(AppUserActions, dispatch),
    interestCheckActions : bindActionCreators(InterestCheckActions, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserInterestCheck as any);



// WEBPACK FOOTER //
// ./src/containers/UserInterestCheck.tsx